<div 
  class="row mt-4 d-flex justify-content-center" 
  role="list" 
  aria-label="Customer Profile Options"
>

  @for (customerProfile of partner?.customer_profiles; track customerProfile; let index = $index; let odd = $odd; let even = $even) {
    <div 
      class="col-lg-4 col-md-4 col-sm-6 mt-3"
      [ngClass]="{ 'offset-md-1': even }"
      role="listitem"
    >
      <app-cw-card
        [cardBodyClass]="'d-flex align-items-center justify-content-center'"
        [cardClass]="(customerProfile.id === appointmentState.customerProfileId) ? 'selected-card cbw-customer-profile-card': 'cbw-customer-profile-card'"
        (cardClickEvent)="onSelectCustomerProfile(customerProfile);"
        [attr.aria-selected]="customerProfile.id === appointmentState.customerProfileId"
        [attr.aria-label]="(customerProfile | translation: 'title': lang) + ' - ' + (customerProfile | translation: 'description': lang)"
        role="option"
      >
        <div body class="d-flex flex-column align-items-center justify-content-center">
          @if (customerProfile.icon) {
            <div aria-hidden="true">
              <fa-icon class="icon customer-profile-icon" [icon]="customerProfile.icon"></fa-icon>
            </div>
          }
          <div class="cbw-title" aria-live="polite">
            {{ customerProfile | translation: 'title': lang }}
          </div>
          <div class="cbw-function text-muted text-center" aria-live="polite">
            {{ customerProfile | translation: 'description': lang }}
          </div>
        </div>
      </app-cw-card>
    </div>
  }

</div>

@if (showStepValidationError() && !appointmentState.customerProfileId) {
  <div
    id="cbw-customer-type-validation-error"
    class="cbw-global-step-error cbw-customer-type-step-error"
    role="alert"
    aria-live="assertive"
    aria-atomic="true"
  >
    <div class="cbw-step-error-text">
      {{ stepErrorTemplate ? (stepErrorTemplate | translation: templateContent.TEMPLATE_CONTENT: lang) : ('alert_messages.next_step_error_customer_type' | translate) }}
    </div>
  </div>
}

<div class="d-flex align-items-center justify-content-end mt-4 next-btn-custom-right-padding">
  <calenso-button
    type="primary"
    id="{{ 'cbw-next-button' }}"
    text="{{ nextButtonTemplate | translation: templateContent.TEMPLATE_CONTENT: lang }}"
    placement="right"
    [disabled]="+partner?.widget_buttons_always_enabled === 1 ? false : !appointmentState.customerProfileId"
    [widgetColorConf]="widgetColorConf"
    (clickEvent)="onNextButtonClick()"
    [attr.aria-label]="nextButtonTemplate | translation: templateContent.TEMPLATE_CONTENT: lang"
    [attr.aria-disabled]="+partner?.widget_buttons_always_enabled === 1 ? false : !appointmentState.customerProfileId"
    [attr.aria-describedby]="showStepValidationError() && !appointmentState.customerProfileId ? 'cbw-customer-type-validation-error' : null"
  />
</div>
